<template>
  <div
    ref="cardEl"
    class="card-landscape-big landscape"
    :style="{ ...cardElVarStyles, ...cardElStyles }"
  >
    <div class="media-container" v-if="parentGeneral.showCardsMedia">
      <slot name="media" />
    </div>

    <div class="content-container">
      <div class="header-text-container">
        <slot name="header" />
        <slot name="text" />
      </div>

      <div class="button-container">
        <slot name="ctaButton" />
      </div>
    </div>
  </div>
</template>

<script>
import { cardComputed, cardProps } from "../mixins/card";

export default {
  name: "CardLandscapeBig",
  mixins: [cardComputed, cardProps],
};
</script>

<style lang="scss" scoped>
@import "../scss/shared.scss";
@import "../scss/landscape.scss";

.media-container {
  min-height: 600px;

  @include mobile {
    min-height: 350px;
  }
}
</style>
